// J&T "Problematic" scan reasons (value === label, as returned by J&T TRACKQUERY).
// Generated by scanning all ph-fb orders created in 2026 (day by day), sorted by frequency.
// Exact strings are kept (incl. trailing dots) because the filter matches stored values exactly.
export default [
    "The call is Turned Off.",
    "No Reason to Reject without Opening the Box",
    "Change of Delivery Time",
    "No one Answers the Phone",
    "Not yet Picked up at station",
    "Wrong First or Second Segment Code ..",
    "Wrong First or Second Segment Code .",
    "potential switch.",
    "Auto-drop or wrong phone number",
    "waybill damage or information unclear",
    "Wrong Address Information..",
    "Wrong Address Information.",
    "Distribute Warehouse Missplitting..",
    "Center Missplitting..",
    "Distribute Warehouse Missplitting.",
    "Center Missplitting.",
    "dent",
    "potential switch",
    "Address Information not Available..",
    "The Outer Packaging is not Standardized.",
    "Multiple Orders for one Shipment..",
    "Incomplete Waybill Information..",
    "There are dispatched parcels but unarrived..",
    "Damaged Outer Packaging, Intact/ Unsure Inner.",
    "Dent",
    "Inner and Outer Packaging not Standardized.",
    "Deformed Outer Packaging, Intact/ Unsure Inner.",
    "Inner and Outer Packaging not Standardized..",
    "Incomplete Waybill Information.",
    "There are dispatched parcels but unarrived.",
    "Multiple Orders for one Shipment.",
    "Dent.",
    "Mis-issued.",
    "The Outer Packaging is not Standardized..",
    "Contaminated Parts.",
];
